import { showToast } from "vant"
import { API_URL } from "@/common/config"
import PyApiService from "./py-request"
import { Notify } from "@/components"

const ZWActions = {
  call(data) {
    return ZWJSBridge.phoneCall(data)
  },
  chooseImage(data) {
    return ZWJSBridge.chooseImage({ upload: false, ...data })
  },
  saveImage(data) {
    return ZWJSBridge.saveImage(data)
      .then((res) => {
        console.log("saveImage", res)
      })
      .catch((err) => {
        console.error("saveImage", err)
      })
  },
  setClipboardData(data) {
    return ZWJSBridge.setClipboardData({
      text: data
    })
  },
  downloadFile(data) {
    return ZWJSBridge.downloadFile(data)
      .then((res) => {
        console.log("downloadFile", res)
      })
      .catch((err) => {
        console.error("downloadFile", err)
      })
  },
  chooseFile(data) {
    return new Promise((resolve, reject) => {
      ZWJSBridge.onReady(() => {
        ZWJSBridge.uploadFile({
          url: `${API_URL}commonzlb/upload/`,
          ...data,
          onSuccess: (res) => {
            resolve(res)
          },
          onFail: (err) => {
            reject(err)
          }
        }).catch((err) => {
          reject(err)
        })
      })
    })
  },
  ssoTicket() {
    function login(ticketId) {
      return PyApiService.get("talent_cert/login/zlb_sso_login", {
        params: { ticketId }
      }).then(({ result, data }) => {
        return { success: result === "ok", data }
      })
    }

    if (isZWEnv() && process.env.NODE_ENV === "production") {
      return new Promise((resolve, reject) => {
        ZWJSBridge.ssoTicket({})
          .then((ssoFlag) => {
            const { result, ticketId } = ssoFlag
            if (result) {
              login(ticketId).then((res) => {
                resolve(res)
              })
            }
          })
          .catch((err) => {
            reject(err)
          })
      })
    } else {
      return Promise.reject()
      //return login("debug_tk_e4a0dc3fcc8d464ba336b9bcb1ba2072")
    }
  },
  openLink(data) {
    return new Promise((resolve, reject) => {
      ZWJSBridge.openLink(data)
        .then((result) => {
          resolve(result)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  getLocation() {
    return ZWJSBridge.getLocation()
  }
}

export const ZWApis = ({ action, data }) => {
  return new Promise((resolve, reject) => {
    try {
      ZWJSBridge.onReady(() => {
        ZWActions[action](data).then(resolve).catch(reject)
      })
    } catch (err) {
      console.error(err)
      reject(err)
    }
  })
}

export const isZWEnv = () => {
  // 浙里办客户端
  if (/ZLB/.test(window.navigator.userAgent)) {
    return true
  } else {
    return false
  }
}

export const envJudge = () => {
  const sUserAgent = window.navigator.userAgent.toLowerCase()
  const isIos = !!sUserAgent.match(/\(i[^;]+;( U;)? cpu.+mac os x/)
  const isAndroid = /android/.test(sUserAgent)
  const bIsDtDreamApp = sUserAgent.indexOf("dtdreamweb") > -1
  const bIsZlbMiniprogram = sUserAgent.indexOf("miniprogram") > -1
  //浙里办环境 包括app、支付宝微信小程序
  const isZlb = bIsDtDreamApp || bIsZlbMiniprogram
  //浙里办app
  const isZlbApp = bIsDtDreamApp
  //浙里办支付宝小程序
  const isZlbAlipay = bIsZlbMiniprogram && sUserAgent.indexOf("alipay") > -1
  //浙里办微信小程序
  const isZlbWechat = sUserAgent.indexOf("micromessenger") > -1
  return {
    isIos,
    isAndroid,
    isZlb,
    isZlbApp,
    isZlbAlipay,
    isZlbWechat
  }
}

// 打电话
export const callPhone = (phone) => {
  if (isZWEnv()) {
    ZWApis({ action: "call", data: { corpId: phone } }).catch(() => {
      window.open(`tel:${phone}`, "_self")
    })
  } else {
    window.open(`tel:${phone}`, "_self")
  }
}

function copyToClipboard(text) {
  const input = document.createElement("input")
  input.style.position = "fixed"
  input.style.opacity = 0
  input.value = text
  document.body.appendChild(input)
  input.select()
  document.execCommand("copy")
  document.body.removeChild(input)
  showToast("已复制")
}
// 复制到剪贴板
export const setClipboardData = (text) => {
  if (isZWEnv()) {
    ZWApis({ action: "setClipboardData", data: text })
      .then(() => {
        showToast("已复制")
      })
      .catch(() => {
        copyToClipboard(text)
      })
  } else {
    copyToClipboard(text)
  }
}

// 获取定位
export const getLocation = (showError = false) => {
  return new Promise((resolve, reject) => {
    if (isZWEnv()) {
      ZWApis({ action: "getLocation", data: {} })
        .then((res) => {
          resolve(res)
        })
        .catch((err) => {
          showError && Notify.error("获取地理位置失败，请确认是否开启定位权限")
          reject(err)
        })
    } else {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          function (position) {
            let latitude = position.coords.latitude
            let longitude = position.coords.longitude
            let data = {
              latitude: latitude,
              longitude: longitude
            }
            resolve(data)
          },
          function (error) {
            showError && Notify.error("获取地理位置失败")
            reject(error)
          },
          {
            timeout: 3000 // 设置超时时间为3秒
          }
        )
      } else {
        showError && Notify.error("你的浏览器不支持当前地理位置信息获取")
        reject("你的浏览器不支持当前地理位置信息获取")
      }
    }
  })
}
